<!--
 * @Author: hfxie
 * @Date: 2022-05-30 11:24:53
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-11-07 09:01:24
 * @Description: 右侧图区·撑满单大行·空横道
    @dragenter.stop.prevent
    @dragover.stop.prevent
    @dragleave.stop.prevent
    @drop.stop.prevent="DropHandle($event, emptyBarInfo)"
-->
<template>
  <div
    class="empty-task"
    v-show="isShow"
    :style="{
      'top': emptyBarInfo._top + 'px',
      'left': emptyBarInfo._left + 'px',
      'width': emptyBarInfo._width + 'px',
      'height': emptyBarInfo._height + 'px',
      'background-color': emptyBarInfo._bgColor,
    }"
  >
    <span
        class="empty-task-info"
        v-show="emptyBarInfo.labelIsShow && emptyBarInfo._width >= 20"
        :title="emptyBarInfo.innerDesc"
      >{{emptyBarInfo.innerDesc}}</span>
  </div>

</template>

<script>
export default {
  name: "EmptyBar",
  data() {
    return {};
  },
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
    emptyBarInfo: {
      type: Object,
      default: () => {
        return {
          "_top": 0,
          "_left": 0,
          "_width": 0,
          "_bgColor": "rgba(0,0,0,0.1)",
        };
      },
    },

  },
  methods: {
    
  },
};
</script>
<style scoped lang='less'>
.empty-task {
  width: 0;
  height: 36px;
  position: absolute;
  z-index: 500; // 拖拽背景行505以下
  top: 0;
  text-align: center;
  font-size: @fs16;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .empty-task-info{
    float: left;
    display: inline;
    min-width: @fs20;
    padding: 0 5px;
    height: @fs20;
    line-height: @fs20;
    background-color: #009ba8;
    color: #fff;
  }
}

</style>
